import React from 'react';
import { useSelector } from 'react-redux';
import brightnessColor from '~/src/lib/common/utils/brightnessColor';

function App(props) {
    const { bloc, index } = props;

    const business = useSelector((state) => state.business);
    const common = useSelector((state) => state.common);
    const headerHeight = useSelector((state) => state.app.headerHeight);

    if (!business) {
        return false;
    }

    if (!business.info) {
        return false;
    }

    const brightnessByColor = brightnessColor(props.color);
    const color = brightnessByColor < 122 ? '#FFFFFF' : '#000000';

    if (
        typeof business.info.bloc_manager_app_title === 'string' &&
        business.info.bloc_manager_app_title.length > 0 &&
        typeof business.info.bloc_manager_app_content === 'string' &&
        business.info.bloc_manager_app_content.length > 0
    ) {
        return (
            <div
                id="homebloc-manager"
                style={{
                    marginTop: index === 0 ? headerHeight + 10 : 0,
                }}
            >
                <div
                    className="homebloc-manager-title"
                    style={{ color: color }}
                >
                    {business.info.bloc_manager_app_title}
                </div>
                <div
                    className="homebloc-manager-content"
                    style={{ color: color }}
                >
                    {business.info.bloc_manager_app_content}
                </div>
            </div>
        );
    }

    // cyrille à supprimer, display_bloc_html sera une string

    if (
        typeof business.info.bloc_manager_app_title !== 'object' &&
        typeof business.info.bloc_manager_app_title.val !== 'string'
    ) {
        return false;
    }

    if (
        typeof business.info.bloc_manager_app_content !== 'object' &&
        typeof business.info.bloc_manager_app_content.val !== 'string'
    ) {
        return false;
    }

    return (
        <div
            id="homebloc-manager"
            style={{
                marginTop: index === 0 ? headerHeight + 10 : 0,
            }}
        >
            <div className="homebloc-manager-title" style={{ color: color }}>
                {business.info.bloc_manager_app_title.val}
            </div>
            <div className="homebloc-manager-content" style={{ color: color }}>
                {business.info.bloc_manager_app_content.val}
            </div>
        </div>
    );
}

export default App;
